<cmps-dialog
    class="cmps-event-centre-c-pop-base-v2--dialog cmps-cdk-border-width-0p cmps-cdk-p-0"
    [class.cmps-event-centre-c-pop-dialog--multiple]="_data?.multiple"
>
    <cmps-dialog-header
        class="cmps-cdk-pt-0dot5 cmps-cdk-px-1"
        [closeTooltip]="_i18n._763_CLOSE | translate"
    ></cmps-dialog-header>
    <cmps-dialog-body>
        <div #containerRef>
            <ng-container #ref></ng-container>
        </div>
        <cmps-event-centre-c-pop-footer></cmps-event-centre-c-pop-footer>
    </cmps-dialog-body>
</cmps-dialog>
